<template>
	<div class="cert-wrapper">
		<!-- 头部 -->
		<header class="cert-header">
			<h1>
				{{ institutionName }}
			</h1>
			<span class="badge-valid">证书验证有效</span>
		</header>

		<!-- 主体 -->
		<main class="cert-body">
			<div class="cert-image">
				<img :src="imageUrl" alt="证书照片" @error="handleImageError" />
			</div>

			<div class="cert-details">
				<div v-for="(item, index) in detailItems" :key="index" class="detail-item">
					<span class="detail-label">{{ item.label }}</span>
					<span class="detail-value">{{ item.value || '—' }}</span>
				</div>
				<div class="detail-item">
					<span class="detail-label">{{ otherlabel }}</span>
					<span class="detail-value">{{ othervalue || '—' }}</span>
				</div>
				<div class="detail-item" style="border-bottom: none; margin-top: 6px;">
					<span class="detail-label">防伪码</span>
					<span class="detail-value" style="font-family: monospace; letter-spacing: 2px; color: #b8860b;">
						{{ antiFakeCode }}
					</span>
				</div>
			</div>

			<div class="verify-tip">
				<i class="fa fa-check-circle"></i> 本证书由 <strong>{{ institutionName }}</strong> 组织方颁发，可通过官方渠道验证
			</div>
		</main>

		<!-- 底部 -->
		<footer class="cert-footer">
			<span class="verify-time">
				<i class="fa fa-clock-o"></i> 验证时间：{{ verifyTime }}
			</span>
			<span class="official-link">
				<i class="fa fa-shield"></i>
				<a :href="officialUrl" target="_blank" rel="noopener noreferrer">
					{{ officialUrlText }}
				</a>
			</span>
		</footer>
	</div>
</template>

<script>
	// 导入您原有的 API 方法（假设路径正确）
	import {
		verificationCertificate
	} from '../../api/userMG'

	export default {
		name: 'VerificationCertificate',
		data() {
			return {
				// 证书数据（从后端获取后赋值）
				imageId: '',
				studentName: '',
				certCode: '',
				teacher: '',
				issuer: '',
				otherlabel: '',
				othervalue: '',
				institutionName: '科教枢认证中心',
				officialUrl: 'https://example.com/verify',
				officialUrlText: '前往官方验证',
				verifyTime: '',
				antiFakeCode: '',

				// 额外字段（原有逻辑中用到的）
				userName: '',
				userRole: '',
				localRegistered: false
			}
		},
		computed: {
			imageUrl() {
				if (!this.imageId) return ''
				const base = 'https://robotcer-1305194676.cos.ap-guangzhou.myqcloud.com/'
				console.log(123,base + this.imageId + '.jpg')
				return base + this.imageId + '.jpg'
			},
			detailItems() {
				const items = []
				if (this.studentName) items.push({
					label: '姓　名',
					value: this.studentName
				})
				if (this.certCode) items.push({
					label: '证书编号',
					value: this.certCode
				})
				if (this.teacher) items.push({
					label: '指导老师',
					value: this.teacher
				})
				if (this.issuer) items.push({
					label: '颁发机构',
					value: this.issuer
				})
				if (items.length === 0) items.push({
					label: '信息',
					value: '暂无数据'
				})
				return items
			}
		},
		created() {
			// 1. 生成验证时间
			const now = new Date()
			const pad = n => String(n).padStart(2, '0')
			this.verifyTime =
				`${now.getFullYear()}-${pad(now.getMonth()+1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`

			// 2. 生成防伪码
			this.antiFakeCode = this.generateAntiFakeCode()
			// 3. 获取路由参数并调用 API
			const query = this.$route.query
			this.imageId = query.id
			if (query.id && query.code && query.cid) {
				verificationCertificate(query.id, query.code, query.cid).then(re => {
					if (re) {
						this.studentName = re[2]
						this.certCode = re[7]
						this.teacher = re[3]
						this.institutionName = re[4]
						this.issuer = re[5]
						this.otherlabel = re[6]
						this.othervalue = re[1]
					}
				}).catch(err => {
					console.error('获取证书信息失败', err)
				})
			}
		},
		methods: {
			handleImageError(e) {
				e.target.src =
					'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="300" viewBox="0 0 400 300"%3E%3Crect width="400" height="300" fill="%23f0f0f0"/%3E%3Ctext x="50%25" y="50%25" dominant-baseline="middle" text-anchor="middle" font-family="sans-serif" font-size="20" fill="%23999"%3E证书图片%3C/text%3E%3C/svg%3E'
			},
			generateAntiFakeCode() {
				const base = this.studentName || 'CERT'
				const num = this.certCode || '0000'
				const ts = Date.now().toString().slice(-6)
				const raw = `${base}${num}${ts}`
				let hash = 0
				for (let i = 0; i < raw.length; i++) {
					hash = ((hash << 5) - hash) + raw.charCodeAt(i)
					hash |= 0
				}
				const hex = Math.abs(hash).toString(16).toUpperCase().padStart(8, '0')
				return `${hex.slice(0,4)}-${hex.slice(4,8)}-${ts.slice(-4)}`
			}
		}
	}
</script>

<style scoped>
	/* 直接将原来 <style> 中的样式复制过来（注意已经 scoped，避免全局污染） */
	* {
		box-sizing: border-box;
	}

	.cert-wrapper {
		max-width: 960px;
		width: 100%;
		margin: 20px auto;
		background: #ffffff;
		border-radius: 16px;
		box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
		overflow: hidden;
		position: relative;
	}

	.cert-wrapper::before {
		content: "✦ 证书验证 ✦ 权威机构 ✦";
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%) rotate(-25deg);
		font-size: 60px;
		font-weight: bold;
		color: rgba(200, 200, 200, 0.08);
		white-space: nowrap;
		pointer-events: none;
		letter-spacing: 12px;
		z-index: 0;
	}

	.cert-header {
		background: linear-gradient(135deg, #1a3a5c 0%, #2a5f8f 100%);
		padding: 22px 30px;
		color: #fff;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 4px solid #d4a84b;
		position: relative;
		z-index: 1;
	}

	.cert-header h1 {
		margin: 0;
		font-size: 26px;
		font-weight: 600;
		letter-spacing: 2px;
	}

	.cert-header h1 small {
		font-size: 16px;
		font-weight: 300;
		opacity: 0.85;
		margin-left: 15px;
	}

	.badge-valid {
		background: #28a745;
		color: #fff;
		padding: 8px 24px;
		border-radius: 30px;
		font-size: 18px;
		font-weight: bold;
		letter-spacing: 2px;
		box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.3);
		animation: pulse-green 2s infinite;
	}

	@keyframes pulse-green {
		0% {
			box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.4);
		}

		70% {
			box-shadow: 0 0 0 12px rgba(40, 167, 69, 0);
		}

		100% {
			box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);
		}
	}

	.cert-body {
		padding: 30px 30px 10px;
		position: relative;
		z-index: 1;
	}

	.cert-image {
		text-align: center;
		margin-bottom: 25px;
	}

	.cert-image img {
		max-width: 100%;
		max-height: 500px;
		border-radius: 10px;
		box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
		border: 1px solid #e9ecef;
		object-fit: contain;
	}

	.cert-details {
		background: #fafcff;
		border-radius: 10px;
		padding: 20px 28px;
		border-left: 6px solid #d4a84b;
		box-shadow: inset 0 1px 4px rgba(0, 0, 0, 0.02);
	}

	.detail-item {
		display: flex;
		padding: 8px 0;
		border-bottom: 1px dashed #e9ecef;
		font-size: 16px;
		line-height: 1.8;
	}

	.detail-item:last-child {
		border-bottom: none;
	}

	.detail-label {
		width: 130px;
		font-weight: 600;
		color: #2c3e50;
		flex-shrink: 0;
	}

	.detail-value {
		color: #1a3a5c;
		word-break: break-all;
	}

	.verify-tip {
		margin-top: 20px;
		padding: 12px 16px;
		background: #e8f0fe;
		border-radius: 8px;
		color: #1a3a5c;
		font-size: 14px;
		border-left: 4px solid #2a5f8f;
	}

	.verify-tip i {
		color: #2a5f8f;
		margin-right: 6px;
	}

	.cert-footer {
		background: #f8f9fc;
		padding: 16px 30px;
		border-top: 1px solid #e9ecef;
		display: flex;
		justify-content: space-between;
		font-size: 14px;
		color: #6c757d;
		flex-wrap: wrap;
		position: relative;
		z-index: 1;
	}

	.verify-time i {
		margin-right: 6px;
		color: #2a5f8f;
	}

	.official-link a {
		color: #2a5f8f;
		text-decoration: none;
		font-weight: 500;
	}

	.official-link a:hover {
		text-decoration: underline;
	}

	@media (max-width: 768px) {
		.cert-header {
			flex-direction: column;
			align-items: flex-start;
			padding: 16px 20px;
		}

		.cert-header h1 {
			font-size: 20px;
		}

		.badge-valid {
			margin-top: 10px;
			font-size: 15px;
			padding: 5px 18px;
		}

		.cert-body {
			padding: 20px;
		}

		.detail-item {
			flex-direction: column;
			padding: 6px 0;
		}

		.detail-label {
			width: 100%;
			font-size: 14px;
		}

		.cert-footer {
			flex-direction: column;
			align-items: center;
			gap: 6px;
		}
	}

	@media print {
		body {
			background: #fff;
			padding: 0;
		}

		.cert-wrapper {
			box-shadow: none;
			border: 1px solid #ccc;
		}

		.cert-header {
			background: #1a3a5c !important;
			-webkit-print-color-adjust: exact;
		}

		.badge-valid {
			-webkit-print-color-adjust: exact;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/user/verificationCertificate.vue